import { Injectable } from "@angular/core";

import { ITabStorage, TabStorage } from "../../models/tab-data-storage";
import { LIST_KIND_NAME } from "src/app/infrastructure/services/list-services/_list.service";
import { SignalTree } from "../../types/signal-tree.type";
import { TabPageStorageService } from "./tab-page-storage.service";
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';


@Injectable()
export class TabListStorageService
    extends TabPageStorageService
{
    protected readonly _listName = injectRequired(LIST_KIND_NAME);

    // Scroll-, filter- en pagineringsstate van één lijst, onder het huidige frame. Daalt de gebruiker
    // opnieuw af, dan is het frame nieuw en staat deze lijst dus schoon — zonder expliciete wis-actie.
    get tabData$$(): SignalTree<ITabStorage> {
        return this.pageData$$.lists[this._listName].ensure(() => new TabStorage()) as SignalTree<ITabStorage>;
    }
}
